export const PRESENCE_ENUMS = {
	connected   : 'connected',
	accepted    : 'accepted',
	declined    : 'declined',
	aCall       : 'audioCall',
	vCall       : 'videoCall',
	missed      : 'missed',
	connecting  : 'connecting',
	ringing     : 'ringing',
	invited     : 'invited',
	ended       : 'ended',
	left        : 'left',
	incoming    : 'incoming',
	initiated   : 'initiated',
	outGoing    : 'outGoing',
	onGoing     : 'onGoing',
	noAnswer    : 'No Answer',
	calling     : 'Calling',
	inCall      : 'In call',
	individual  : 'individual',
	group       : 'group',
	message     : 'message',
	meeting     : 'meeting',
	information : 'information',
	audioCall   : 'YXVkaW9DYWxs',
	videoCall   : 'dmlkZW9DYWxs',
	broadcast  	: 'broadcast'

};